export default "__VITE_ASSET__aONBfzMV__"